import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  InputLabel,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Images from "../../common/component/image/Images";
import ConfigContext from "../../common/context/ConfigContext";
import { useContext } from "react";

export default function CakeDetails(props) {
  const siteConfig = useContext(ConfigContext);

  const [showDietary, setShowDietary] = useState(false);
  const [tweak, setTweak] = useState("");
  const [details, setDetails] = useState("");
  const [dietary, setDietary] = useState("");
  const [cakeType, setCakeType] = useState("");
  const [pics, setPics] = useState(props.pics);

  useEffect(() => {
    if (tweak === "no") {
      setDetails("");
    }
  }, [tweak]);

  const onSubmit = (e) => {
    e.preventDefault();
    let arr = [];
    if (dietary) {
      arr.push(dietary);
    }
    if (cakeType && cakeType !== "Not Applicable") {
      if (cakeType === "Baker's Choice") {
        arr.push("I'm ok with either Pound Cake or Layer Cake.");
      } else {
        arr.push(cakeType);
      }
    }
    if (details) {
      arr.push(details);
    }
    const desc = arr.filter(Boolean).join(" • ");
    props.onSubmit({ dietary, details: desc, pics });
  };

  return (
    <Paper>
      <Box px={2} py={7}>
        <Grid container>
          <Grid item sm={2} xs={12}></Grid>
          <Grid item sm={8} xs={12}>
            <Box mb={5} textAlign="center">
              <Typography variant="h2" gutterBottom>
                Customize your Order
              </Typography>
              <Typography variant="body1" color="textSecondary">
                This will be a custom-made order, so you can change pretty much anything
              </Typography>
            </Box>
            <form onSubmit={onSubmit}>
              <Grid container spacing={3} alignItems="center">
                <Grid item sm={4} xs={4}>
                  <Images
                    pics={props.pics}
                    edit={tweak === "yes"}
                    onChange={(images) => setPics(images)}
                    folder={`img/r`}
                    limit={5}
                    max={10}
                  />
                </Grid>
                <Grid item sm={8} xs={8}>
                  {(siteConfig.id === "hVDIMTd6J8yE54OFhssO" ||
                    siteConfig.id === "redcFy8WN7bdMNX0Xmdh" ||
                    siteConfig.id === "SpSIrjY42BUZ5h4I9sOC" ||
                    siteConfig.id === "-MVIf1diaYOCm5KynVDF") && (
                    <Box mb={2}>
                      <FormControl variant="outlined" fullWidth required>
                        <InputLabel id="cakeType">{`Cake Type`}</InputLabel>
                        <Select
                          value={cakeType}
                          labelId="cakeType-label"
                          label={`Cake Type`}
                          id="cakeType"
                          name="cakeType"
                          renderValue={(option) => {
                            return option;
                          }}
                          onChange={(e) => setCakeType(e.target.value)}
                        >
                          <MenuItem value="Layer Cake">
                            <Box>
                              <Typography variant="body1">Layer Cake</Typography>
                              <Typography variant="body2" color="textSecondary">
                                Light & fluffy. Not suitable for tiered cakes.
                              </Typography>
                            </Box>
                          </MenuItem>
                          <MenuItem value="Pound Cake">
                            <Box>
                              <Typography variant="body1">Pound Cake</Typography>
                              <Typography variant="body2" color="textSecondary">
                                Dense, rich & buttery.
                              </Typography>
                            </Box>
                          </MenuItem>
                          <MenuItem value="Baker's Choice">
                            <Box>
                              <Typography variant="body1">Baker's Choice</Typography>
                              <Typography variant="body2" color="textSecondary">
                                We'll pick the best option based on your design.
                              </Typography>
                            </Box>
                          </MenuItem>
                          <MenuItem value="Not Applicable">
                            <Box>
                              <Typography variant="body1">Not Applicable</Typography>
                              <Typography variant="body2" color="textSecondary">
                                Choose for items other than Cakes.
                              </Typography>
                            </Box>
                          </MenuItem>
                        </Select>
                        <FormHelperText>
                          Choose the cake texture - light & fluffy or dense & rich
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  )}
                  <RadioGroup name="tweak" value={tweak} onChange={(e) => setTweak(e.target.value)}>
                    <Box mb={2}>
                      <FormControlLabel
                        value="no"
                        control={<Radio required={true} />}
                        label={`No Customization`}
                      />
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          We'll match the inspiration design to the best of our abilities
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <FormControlLabel
                        value="yes"
                        control={<Radio required={true} />}
                        label={`Customize this design`}
                      />
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          We'll change the inspiration design based on your instructions
                        </Typography>
                      </Box>
                    </Box>
                  </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    {tweak === "yes" && (
                      <Box mt={2}>
                        <FormControl variant="outlined" fullWidth>
                          <TextField
                            value={details}
                            variant="outlined"
                            fullWidth
                            id="details"
                            label=""
                            name="details"
                            multiline
                            rows={3}
                            onChange={(e) => setDetails(e.target.value)}
                            required
                            placeholder="Change tiers, add/remove toppers, decals, toys, figurines, flowers, etc."
                          />
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  {!showDietary && (
                    <Button variant="text" onClick={() => setShowDietary(true)} fullWidth>
                      Add dietary choices
                    </Button>
                  )}
                  {showDietary && (
                    <FormControl variant="outlined" fullWidth>
                      <TextField
                        value={dietary}
                        variant="outlined"
                        id="dietary"
                        label="Dietary choices"
                        name="dietary"
                        fullWidth
                        onChange={(e) => setDietary(e.target.value)}
                        helperText="Nut-free, eggless, vegan, etc"
                      />
                    </FormControl>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Button size="large" color="primary" variant="contained" type="submit" fullWidth>
                    Continue
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
